export const Services = {
  en: {
    Services: 'Services',
    Name: 'Name',
    'Name UA': 'Name (UA)',
    'Service Category': 'Service Category',
    'Service Type': 'Service Type',
    'Discount Type': 'Discount Type',
    Price: 'Price',
    'Visits Count': 'Visits Count',
    'Duration In Days': 'Duration In Days',
    Active: 'Active',
    'Trainer Fee': 'Trainer Fee',
    'Create Service': 'Create Service',
    'Create Service Price': 'Create Service Price',
    'Service Prices': 'Service Prices',
    Reason: 'Reason',
    'Start Date': 'Start Date',
    'End Date': 'End Date',
    'Created By': 'Created By',
    Locations: 'Locations',
    Status: 'Status',
    'Not Active': 'Not Active',
    Visible: 'Visible',
  },
  uk: {
    Services: 'Сервіси',
    Name: 'Назва',
    'Name UA': 'Назва (UA)',
    'Service Category': 'Категорія Сервісу',
    'Service Type': 'Тип Сервісу',
    'Discount Type': 'Тип Знижки',
    Price: 'Ціна',
    'Visits Count': 'Кількість Відвідувань',
    'Duration In Days': 'Тривалість В Днях',
    Active: 'Активний',
    'Trainer Fee': 'Плата Тренеру',
    'Create Service': 'Створити Сервіс',
    'Create Service Price': 'Створити Ціну Сервісу',
    'Service Prices': 'Ціни Сервісу',
    Reason: 'Причина',
    'Start Date': 'Дата Початку',
    'End Date': 'Дата Закінчення',
    'Created By': 'Створено',
    Locations: 'Локації',
    Status: 'Статус',
    'Not Active': 'Не активний',
    Visible: 'Видимий',
  },
};

export const ServiceForm = {
  en: {
    ...Services.en,
    'New Service': 'New Service',
    'Edit Service': 'Edit Service',
    'Update Service': 'Update Service',
    'Trainer Required': 'Trainer Required',
    Discounts: 'Discounts',
    Category: 'Category',
    'Discount (%)': 'Discount (%)',
    'Select Category': 'Select Category',
    'Add Discount': 'Add Discount',
    'No discounts added': 'No discounts added',
    'Club card': 'Club card',
    'Client self usage': 'Client self usage',
    'Services Warning':
      'User accounts must be confirmed by an admin before using self check-in.',
    'Set a new price for this service. The change will be recorded with a reason.':
      'Set a new price for this service. The change will be recorded with a reason.',
  },
  uk: {
    ...Services.uk,
    'New Service': 'Створення Сервісу',
    'Edit Service': 'Редагування Сервісу',
    'Update Service': 'Оновити Сервіс',
    'Trainer Required': 'Потрібен Вибір Тренера',
    Discounts: 'Знижки',
    Category: 'Категорія',
    'Discount (%)': 'Знижка (%)',
    'Select Category': 'Оберіть Категорію',
    'Add Discount': 'Додати Знижку',
    'No discounts added': 'Знижки не додано',
    'Club card': 'Клубна картка',
    'Client self usage': 'Самостійне використання клієнтом',
    'Services Warning':
      'Для самостійного входу клієнт має бути підтверджений адміністратором',
    'Set a new price for this service. The change will be recorded with a reason.':
      'Встановіть нову ціну для цього сервісу. Зміна буде записана з причиною.',
  },
};
